import { cancelableFetch } from "./cancelable-fetch.js";
import { ApiMethod, FetchOptions } from "../types.js";
import { BlobContentType, FetchContentType } from "@hokuto/jam-core";

export function apiProps(url: string, options: FetchOptions = {}) {
  const {
    method = ApiMethod.Get,
    params,
    headers = {},
    cache = "default",
    priority,
  } = options;
  let { body } = options;
  let qs;

  switch (method) {
    case ApiMethod.Get:
      qs =
        params &&
        new URLSearchParams(
          Object.keys(params).reduce((prev, curr) => {
            return { ...prev, [curr]: String(params[curr]) };
          }, {})
        );
      break;
    default:
      if (params) body = JSON.stringify(params);
  }

  url = `${url}${qs ? "?" + qs.toString() : ""}`;
  return { url, headers, cache, method, body, priority };
}

export function jsonFetch<T>(baseurl: string, options: FetchOptions = {}) {
  const { cache, headers, url, method, body } = apiProps(baseurl, options);

  return cancelableFetch(url, {
    method,
    body,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...headers,
    },
    priority: "high",
    cache,
  })
    .then((res) => {
      if (res.ok) return res.json();
      return res.text().then((err) => Promise.reject(new Error(err)));
    })
    .then(
      (data: T) => {
        return Promise.resolve(data);
      },
      (err) => {
        return Promise.reject(err);
      }
    );
}

export function uploadFetch<T = string>(
  baseurl: string,
  options: FetchOptions = {},
  contentType = FetchContentType.Json
) {
  const { cache, headers, url, method, body } = apiProps(baseurl, options);

  return cancelableFetch(url, {
    method,
    body,
    headers,
    cache,
  })
    .then((res) => {
      if (res.ok)
        return contentType === FetchContentType.Json ? res.json() : res.text();
      return res.text().then((err) => Promise.reject(new Error(err)));
    })
    .then(
      (data: T) => {
        return Promise.resolve(data);
      },
      (err) => Promise.reject(err)
    );
}

export function blobFetch(
  baseurl: string,
  options: FetchOptions = {},
  contentType = BlobContentType.Json
) {
  const { cache, headers, url, method, body, priority } = apiProps(
    baseurl,
    options
  );

  return cancelableFetch(url, {
    method,
    body,
    headers: {
      "Content-Type": BlobContentType.Json,
      Accept: contentType,
      ...headers,
    },
    priority,
    cache,
  }).then((res) => res.blob());
}

export function pngFetch(baseurl: string, options: FetchOptions = {}) {
  return blobFetch(baseurl, options, BlobContentType.Image);
}

export function svgFetch(baseurl: string, options: FetchOptions = {}) {
  return blobFetch(baseurl, options, BlobContentType.Svg);
}
